import {useContext} from "react"
import {LocalContext} from "../contexts/LocalContext"

export function useLocalContext() {
    const context = useContext(LocalContext)
    if (!context) {
        throw new Error("useLocalContext must be used within a LocalProvider")
    }
    return context
}